var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation-sent-pane"},[_c('signup-header-section',{attrs:{"steps":1,"pageTitle":_vm.$tc('SignupPage.Steps.Step1')}}),_c('confirmation-sent-section',{staticClass:"confirmation-sent-pane__content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }